export default __webpack_public_path__ + "static/media/hat.8383350a.svg";